/**
 * No-op function: does nothing
 *
 * This helper can be used as default value. The function referential
 * identity makes it safe to use with React without causing unnecessary
 * renders.
 */
export function noop() {}

/**
 * Identity function: returns its first argument
 *
 * This helper can be used as default value. The function referential
 * identity makes it safe to use with React without causing unnecessary
 * renders.
 */
export function identity<TInput, TOutput>(value: TInput): TOutput

export function identity<TValue>(value: TValue): TValue {
    return value
}
